"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeObjectToQueryParam = void 0;
var SerializerService_1 = require("../service/SerializerService");
var encodeObjectToQueryParam = function (options) {
    var currentPayload = {};
    var queryParamsCollection = new Array();
    var nonNullablePayload = SerializerService_1.SerializerService.stripNullableProperties(options.payload);
    var _loop_1 = function (key, value) {
        switch (true) {
            case typeof value === 'string':
                currentPayload[key] = value;
                return "continue";
            case typeof value === 'object':
                if (Array.isArray(value)) {
                    value.forEach(function (item) {
                        queryParamsCollection.push("&".concat(key, "=").concat(item));
                    });
                    return "continue";
                }
                currentPayload[key] = JSON.stringify(value);
                return "continue";
            case typeof value === 'undefined': return "continue";
            default:
                currentPayload[key] = JSON.stringify(value);
        }
    };
    for (var _i = 0, _a = Object.entries(nonNullablePayload); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        _loop_1(key, value);
    }
    var stringOfQueryParams = new URLSearchParams(currentPayload).toString();
    if (!!queryParamsCollection.length) {
        return "".concat(stringOfQueryParams).concat(queryParamsCollection.join(''));
    }
    return stringOfQueryParams;
};
exports.encodeObjectToQueryParam = encodeObjectToQueryParam;
